"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metaphysics = metaphysics;
exports.query = query;

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

require("isomorphic-fetch");

var sharify = _interopRequireWildcard(require("sharify"));

var _errors = require("./errors");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function metaphysics(payload, user) {
  var checkStatus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var headers = {
    "Content-Type": "application/json",
    "User-Agent": "Reaction" // TODO: rename User to AuthTokens and conver to union type

  };
  var AuthHeaders = !!user ? !!user.appToken ? {
    "X-XAPP-TOKEN": user.appToken
  } : {
    "X-USER-ID": user.id,
    "X-ACCESS-TOKEN": user.accessToken
  } : null;
  return fetch(sharify.data.METAPHYSICS_ENDPOINT, {
    method: "POST",
    headers: !!user ? _objectSpread({}, headers, AuthHeaders) : headers,
    body: JSON.stringify(payload)
  }).then(function (response) {
    if (!checkStatus || response.status >= 200 && response.status < 300) {
      return response;
    } else {
      var error = new _errors.NetworkError(response.statusText);
      error.response = response;
      throw error;
    }
  }).then(function (response) {
    return response.json();
  });
}

function query(document) {
  return metaphysics({
    query: document
  }).then(function (_ref) {
    var data = _ref.data;
    return data;
  });
}
//# sourceMappingURL=metaphysics.js.map